"use client";
import Link from "next/link";
import { Button } from "~/components/v3/themed/Button";
import { CommunityAvatar } from "~/components/v4/shadcn/CommunityAvatar";
import WhiteBreakpointStar from "./WhiteBreakpointStar";
import { DiscoveryCommunity, WaitlistCommunity } from "../actions";

type Props = WaitlistCommunity | DiscoveryCommunity;

export const CommunityWaitlistCardsList = ({
    communities,
}: {
    communities: Props[];
}) => {
    return (
        <div className="flex w-full flex-col gap-4">
            {communities?.map((community) => (
                <CommunityWaitlistCard
                    key={community.id}
                    community={community}
                />
            ))}
        </div>
    );
};

const CommunityWaitlistCards = ({ communities }: { communities: Props[] }) => {
    return (
        <div>
            <div className="mb-4 grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                {communities?.map((community) => (
                    <CommunityWaitlistCard
                        key={community.id}
                        community={community}
                    />
                ))}
            </div>
        </div>
    );
};

export const CommunityWaitlistCard = ({ community }: { community: Props }) => {
    return (
        <div
            className="flex h-[318px] w-full flex-col rounded-lg border border-v3-N-600 bg-v3-N-600 p-4"
            key={community.id}
        >
            {/* Community header with avatar and name */}
            <Link
                href={`/beta/${community.slug}`}
                className="flex items-center gap-3"
            >
                <CommunityAvatar
                    community={{
                        id: community.id,
                        name: community.name,
                        image: community.image,
                    }}
                    width={40}
                    height={40}
                />
                <div>
                    <h3 className="text-[24px] font-[500] text-white">
                        {community.name}
                    </h3>
                </div>
            </Link>
            <p className="mt-4 line-clamp-4 text-v3-N-300">
                {community.description}
            </p>
            {/* Spacer to push the badge and button to the bottom */}
            <div className="flex-grow" />
            {/* Category Badge - now with inline-flex to take only required width */}
            <div className="mb-4 space-x-2">
                {community.categories?.map((category) => {
                    return (
                        <span
                            key={`${category}-${community.id}`}
                            className="inline-flex items-center rounded-full bg-white/15 px-2 py-1 text-xs text-white"
                        >
                            {category}
                        </span>
                    );
                })}
            </div>
            {/* Action button */}
            <div>
                <Link href={`/beta/${community.slug}`}>
                    <Button variant="secondary" className="w-full">
                        Join waitlist
                    </Button>
                </Link>
            </div>
        </div>
    );
};

export default CommunityWaitlistCards;
